const g = {
	el: {
		accordions: document.querySelectorAll(".accordion"),
		counters: document.querySelectorAll(".counter"),
		videos: document.querySelectorAll(".video__container"),
		augl: document.querySelectorAll(".augl"),
		modal: document.querySelectorAll(".modal"),
		header: document.querySelectorAll(".header"),
		tabs: document.querySelectorAll(".tabs"),
		productFilters: document.querySelectorAll(".productfilter"),
		customers: document.querySelectorAll(".customer"),
		ulAccords: document.querySelectorAll(".ulaccord"),
		saga: document.querySelectorAll(".saga"),
		fieldControls: document.querySelectorAll(".field__control"),
		searchResults: document.querySelector(".search"),
		hyphenText: document.querySelectorAll(".hyphen"),
		pamphlets: document.querySelectorAll(".docs__container"),
		recipesNavigationMobile: document.querySelectorAll(
			".recipes-navigation__nav--mobile",
		),
		newsletterBlocks: document.querySelectorAll(".newsletter-block"),
		vidmodal: document.querySelectorAll(".vidmodal"),
	},
	form: {
		contact: document.querySelector(".js-contact-form"),
	},
  breakpoints: {
    // xxs: '(min-width: 0px) and (max-width: 369px)',
    // xs: '(min-width: 370px) and (max-width: 575px)',
    // s: '(min-width: 576px) and (max-width: 774px)',
    // m: '(min-width: 775px) and (max-width: 991px)',
    // l: '(min-width: 992px) and (max-width: 1124px)',
    // xl: '(min-width: 1125px) and (max-width: 1299px)',
    // xxl: '(min-width: 1300px) and (max-width: 1699px)',
    // xxxl: '(min-width: 1700px)',
    mobile: '(max-width: 774px)', // xxs/xs/s
    tablet: '(min-width: 775px) and (max-width: 1124px)', // m/l
    desktop: '(min-width: 1125px)', // xl/xxl/xxxl
  },
};

export default g;
